import React, {Component } from 'react';
import { deletePost } from '../../store/actions/postActions';
import { connect } from 'react-redux';

class DeleteModal extends Component {
    handleDelete = (e) => {
        e.preventDefault();
        this.props.deletePost(this.props.id);
        this.props.history.push('/');
    }
    
    render() {
        const {id, show, handleClose, history} = this.props;

        if(!show) {
            return null;
        }

        const showHideClassName = show ? "modal open" : "modal";
        const style = show ? openedModalStyle : {};

        return (
            <div id="confirmDeleteModal" className={showHideClassName} style={style}>
              <div className="modal-content">
                <h4>Deletion</h4>
                <p>Are you sure you want to delete this post?</p>
              </div>
              <div className="modal-footer modal-buttons">
                <button className="waves-effect waves-effect waves-light red btn" onClick={this.handleDelete}>Confirm</button>
                <button className="modal-close waves-effect waves-light grey btn" onClick={handleClose}>Cancel</button>
              </div>
            </div>
        )
    }
}

const openedModalStyle = {
    zIndex: '1003',
    display: 'block',
    opacity: '1',
    top: '10%', 
    transform: 'scaleX(1) scaleY(1)'
}

const mapStateToProps = (state, ownProps) => {
    return {
        id: ownProps.postid,
        show: ownProps.show,
        handleClose: ownProps.handleClose,
        history: ownProps.history
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        deletePost: (id) => dispatch(deletePost(id)) // passing in the project
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteModal);